import React, { useEffect } from 'react';
import useMenu from '../useMenu';


import * as S from './styled';

const Navigation = () => {
  const menuItems = useMenu();
  
  
  return (
    <>
      <S.Navigation>
      
        {menuItems.map(menu => (
          <S.NavigationLink
            key={menu.name}
            to={menu.link}
            aria-label={menu.name}
            
            className={typeof window !== 'undefined' && location.pathname.includes(menu.link) ? 'current' : ''} >
            
            {menu.name}
          </S.NavigationLink>
        ))}


      </S.Navigation>
    </>
  );
};

export default Navigation;
